"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

// <tt> is obsolete and missing from React's JSX types. The Super console
// still renders keys in it, so this keeps the same element and styling.
const Tt = ({ children }) =>
  _react2.default.createElement('tt', null, children)

exports. default = Tt
